import _ from "lodash";
import React from "react";
import update from "immutability-helper";
import classes from "./UIInputList.scss";
import UIBaseComponent from "UIComponents/UIBaseComponent";
import InputItem from "../InputItem";
import { generateRandomId } from "Utils";
import I18nHOC from "UIComponents/I18nHOC";
import EmptyField from "UIComponents/EmptyField";
import { IconButton, Button, Tooltip } from "@toddle-edu/ds-web";
import { AddOutlined, MinusCircleOutlined } from "@toddle-edu/ds-icons";

class UIInputList extends UIBaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      currentFocusIndex: null,
      editingItem: null,
    };
    this.inputListItems = {};
    this.focusedCount = 0;
  }

  updateFocusedCount = ({ value, index }) => {
    const updatedFocusedCount = this.focusedCount + value;

    if (this.focusedCount == 0 && updatedFocusedCount != 0) {
      this.onFocus();
    } else if (updatedFocusedCount == 0 && this.focusedCount != 0) {
      this.onBlur();
    }
    this.focusedCount = updatedFocusedCount;
    if (value == 1) {
      setTimeout(() => {
        this.setState({ currentFocusIndex: index });
      });
    } else {
      this.setState({ currentFocusIndex: null });
    }
  };

  blur = () => {
    _.map(this.inputListItems, itemRef => {
      if (itemRef) {
        itemRef.blur();
      }
    });
  };

  isValidValue = value => {
    return value && _.size(value) > 0;
  };

  emptyObj = () => {
    return {
      id: generateRandomId(),
      value: "",
      isSelected: false,
    };
  };

  componentDidMount = () => {
    const { value } = this.props;

    if (_.get(value, "length") == 0) {
      this.handleEmptyValue();
    }
  };

  componentWillUnmount = () => {};

  shouldShowEditEmpty = () => {
    return false;
  };

  renderEditEmpty = () => {
    const { emptyText, emptyEditText } = this.props;
    return <EmptyField title={emptyEditText || emptyText} />;
  };

  handleEmptyValue = () => {
    this.updateListValue(
      {
        text: "",
        index: 0,
        action: "ADD",
      },
      false
    );
  };

  componentDidUpdate = prevProps => {
    if (
      _.get(this.props.value, "length", 0) == 0 ||
      !_.isEqualWith(prevProps.options, this.props.options, "id")
    ) {
      this.handleEmptyValue();
    }
  };

  updateCurrentFocusIndex = val => {
    this.setState({ currentFocusIndex: val });

    setTimeout(() => {
      if (this.inputListItems[val]) {
        this.inputListItems[val].focus();
      }
    });
  };

  getPreviousIndex = index => {
    let previousIndex = index;
    if (index == 0) {
      previousIndex = 0;
    } else {
      previousIndex = index - 1;
    }
    return previousIndex;
  };

  onItemBlur = () => {
    const { value } = this.props;
    const updatedFocusIndex = _.get(value, "length", 0) - 1;
    this.updateCurrentFocusIndex(updatedFocusIndex);
    this.setState({ editingItem: null });
    this.updateListValue({ isComplete: true });
  };

  _updateValue = updatedArray => {
    this.updateValue(updatedArray);
  };

  updateListValue = (
    { text, index, action, isComplete, isSelected },
    shouldFocus = true
  ) => {
    const { value } = this.props;

    let updatedArray = _.cloneDeep(value);
    let updatedFocusIndex = -1;

    if (isComplete) {
      this._updateValue(updatedArray);
    } else {
      if (action == "EDIT") {
        updatedArray = update(updatedArray, {
          [index]: { value: { $set: text } },
        });
      } else if (action == "ADD") {
        const obj = this.emptyObj();
        updatedArray = update(updatedArray, { $splice: [[index, 0, obj]] });
        updatedFocusIndex = index;
      } else if (action == "REMOVE") {
        if (value.length > 1) {
          updatedArray = update(updatedArray, { $splice: [[index, 1]] });
          updatedFocusIndex = this.getPreviousIndex(index);
        }
      } else if (action === "SELECTION") {
        updatedArray = update(updatedArray, {
          [index]: { isSelected: { $set: isSelected } },
        });
      }
      this._updateValue(updatedArray);
      this.setState({
        editingItem: this.state.editingItem,
      });
    }

    if (updatedFocusIndex >= 0 && shouldFocus) {
      this.updateCurrentFocusIndex(updatedFocusIndex);
    }
  };

  canAdd = () => {
    const { value } = this.props;
    return (
      !value ||
      value.length == 0 ||
      (value.length > 0 && value[value.length - 1].value)
    );
  };

  onAddClick = () => {
    const { value } = this.props;

    this.updateListValue({
      text: "",
      index: value.length,
      action: "ADD",
    });
  };

  onItemEditClicked = ({ id, index }) => {
    this.setState({ editingItem: id });
    if (index >= 0) {
      this.updateCurrentFocusIndex(index);
    }
  };

  updateRef = (index, ref) => {
    this.inputListItems[index] = ref;
  };

  renderItems = () => {
    const { currentFocusIndex } = this.state;
    const {
      value,
      t,
      mode,
      isAIEnabledInRTE,
      isMediaRestricted,
      showDocEditor,
    } = this.props;

    const lengthOfList = _.get(value, "length", 0);

    return _.map(value, (item, index) => {
      const key = item.id;

      return (
        <div key={key} className={classes.inputListItemCon}>
          <div className={classes.inputItemCon}>
            <InputItem
              value={item.value}
              index={index}
              id={item.id}
              onBlur={() =>
                setTimeout(() => this.updateFocusedCount({ value: -1, index }))
              }
              onFocus={() => this.updateFocusedCount({ value: 1, index })}
              isLast={index + 1 === lengthOfList}
              updateListValue={this.updateListValue}
              placeholder={t("worksheet:add_option_text")}
              ref={ref => this.updateRef(index, ref)}
              isEditing={item.id === this.state.editingItem}
              isSelected={item.isSelected}
              onItemBlur={this.onItemBlur}
              mode={mode}
              isCurrentFocused={index === currentFocusIndex}
              isAIEnabledInRTE={isAIEnabledInRTE}
              isMediaRestricted={isMediaRestricted}
              showDocEditor={showDocEditor}
              extendedToolbarButtons={
                <Tooltip
                  tooltip={t("common:delete_with_label", {
                    label: t("common:option"),
                  })}
                >
                  <IconButton
                    onClick={() => {
                      this.updateListValue({
                        index,
                        action: "REMOVE",
                      });
                    }}
                    icon={<MinusCircleOutlined />}
                    dsVersion="2.0"
                    type="plain"
                    variant="neutral"
                    size="small"
                    _legacy_variant="plain"
                    _legacy_size="small"
                    disabled={lengthOfList < 2}
                    testId="worksheet-uiInputList-remove"
                  />
                </Tooltip>
              }
            />
          </div>

          {mode !== "view" && !showDocEditor && (
            <div className={classes.removeButtonContainer}>
              <Tooltip
                tooltip={t("common:delete_with_label", {
                  label: t("common:option"),
                })}
              >
                <IconButton
                  onClick={() => {
                    this.updateListValue({
                      index,
                      action: "REMOVE",
                    });
                  }}
                  icon={<MinusCircleOutlined />}
                  dsVersion="2.0"
                  type="plain"
                  variant="neutral"
                  size="medium"
                  _legacy_variant="plain"
                  _legacy_size="small"
                  disabled={lengthOfList < 2}
                  testId="worksheet-uiInputList-remove"
                />
              </Tooltip>
            </div>
          )}
        </div>
      );
    });
  };

  renderEdit = () => {
    const { t } = this.props;

    return (
      <div className={classes.container}>
        {this.renderItems()}
        <div className={classes.addButtonContainer}>
          <Button
            dsVersion="2.0"
            variant="progressive"
            type="inline"
            size="medium"
            _legacy_variant="inline-progressive"
            icon={<AddOutlined />}
            onClick={this.onAddClick}
            _legacy_size={"medium"}
            testId="worksheet-uiInputList-addOption"
          >
            {t("worksheet:add_option")}
          </Button>
        </div>
      </div>
    );
  };

  renderView = () => {};
}

UIInputList.defaultProps = {
  ...UIBaseComponent.defaultProps,
};

UIInputList.propTypes = {
  ...UIBaseComponent.propTypes,
};

export default I18nHOC({ resource: ["common", "worksheet"] })(UIInputList);
